import { ApiError } from '@/lib/api/errors'
import { friendlyErrorKey } from '@/lib/api/friendly-errors'

/**
 * Login needs two server-specific messages that the generic catalog cannot
 * express: wrong credentials and an unverified email (frozen API contract §2.2).
 */
export function loginErrorKey(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 403) return 'auth.login.emailNotVerified'
    if (error.status === 401) return 'auth.login.invalidCredentials'
    if (error.status === 409) return 'auth.register.emailExists'
  }
  return friendlyErrorKey(error)
}

/** True when the email link token is expired, used, or otherwise invalid. */
export function isInvalidEmailTokenError(error: unknown): boolean {
  return (
    error instanceof ApiError &&
    [400, 401, 404, 410, 422].includes(error.status)
  )
}

/**
 * A `409` on verification means the email changed state between registration
 * and confirmation (D-049); the UI offers a generic recovery plus login
 * instead of claiming the account is active.
 */
export function isEmailConflictError(error: unknown): boolean {
  return error instanceof ApiError && error.status === 409
}
